/* eslint-disable valid-jsdoc */
/* eslint-disable consistent-return */
import PropTypes from 'prop-types'
import accreditationPicto from 'assets/pictures/pictos/Accreditation.png'
import insitu from 'assets/pictures/pictos/insitu.png'
import labo from 'assets/pictures/pictos/labo.png'
import statusIconB from 'assets/pictures/pictos/statusIconB.png'
import statusIconI from 'assets/pictures/pictos/statusIconI.png'
import statusIconN1 from 'assets/pictures/pictos/statusIconN1.png'
import statusIconN2 from 'assets/pictures/pictos/statusIconN2.png'
import {
    ceil,
    find,
    isNil,
    isUndefined,
    max,
    maxBy,
    meanBy,
    minBy,
    orderBy,
    sum,
} from 'lodash'
import React from 'react'
import i18n from 'simple-react-i18n'
import { sieauTooltip } from './FormUtils'
import { hasValue, round } from './NumberUtil'
import { getStatuses } from './QualityUtils'
import { getSetting } from './SettingUtils'
import { IconStatus, statusIcon } from './StatusUtil'
import { getLabel } from './StoreUtils'
import { THRESHOLD_COLOR } from './QualityThresholdUtils'
import { Grid2 } from '@mui/material'

const remarks = [
    // physico-chimique
    {
        id: 0,
        code: 0,
        plot: 'path://m 50 0 l -29.5 90.5 l 77 -56 l -95 0 l 77 56 l -29.5 -90.5 z',
        color: 'black',
        title: '',
        logo: '★',
    }, {
        id: 1,
        code: 1,
        plot: 'path://m 10 50 a 40 40 1 0 0 80 0 a 40 40 0 0 0 -80 0 z',
        color: 'black',
        title: '',
        logo: '●',
    }, {
        id: 2,
        code: 2,
        plot: 'path://m 15 15 l 0 70 l 70 0 l 0 -70 l -70 0 z',
        color: 'black',
        title: '',
        logo: '■',
    }, {
        id: 3,
        code: 3,
        plot: 'path://m 0 50 l 50 -50 l 50 50 l -50 50 l -50 -50 z',
        color: 'black',
        title: '',
        logo: '◆',
    }, {
        id: 7,
        code: 7,
        plot: 'path://m 50 10 l -43 75 l 86 0 l -43 -75 z',
        color: 'black',
        title: '',
        logo: '▲',
    }, {
        id: 10,
        code: 10,
        plot: 'path://m 50 90 l 43 -75 l -86 0 l 43 75 z',
        color: 'black',
        title: '',
        logo: '▼',
    }, {
        id: 11,
        code: 11,
        plot: 'path://m 45 0 h 10 v 45 h 45 v 10 h -45 v 45 h -10 v -45 h -45 v -10 h 45 v -45 z',
        color: 'black',
        title: '',
        logo: '+',
    }, {
        id: 12,
        code: 12,
        plot: 'path://m 18.5 11.5 l 31.5 31.5 l 31.5 -31.5 l 7 7 l -31.5 31.5 l 31.5 31.5 l -7 7 l -31.5 -31.5 l -31.5 31.5 l -7 -7 l 31.5 -31.5 l -31.5 -31.5 l 7 -7 z',
        color: 'black',
        title: '',
        logo: 'x',
    },
    // hydrobio
    {
        id: 4,
        code: 4,
        plot: 'path://m 50 10 l -43 75 l 86 0 l -43 -75 z',
        color: 'black',
        title: '',
        logo: '▲',
    }, {
        id: 5,
        code: 5,
        plot: 'path://m 50 0 l -29.5 90.5 l 77 -56 l -95 0 l 77 56 l -29.5 -90.5 z',
        color: 'black',
        title: '',
        logo: '★',
    }, {
        id: 6,
        code: 6,
        plot: 'path://m 0 50 l 50 -50 l 50 50 l -50 50 l -50 -50 z',
        color: 'black',
        title: '',
        logo: '◆',
    }, {
        id: 8,
        code: 8,
        plot: 'path://m 15 15 l 0 70 l 70 0 l 0 -70 l -70 0 z',
        color: 'black',
        title: '',
        logo: '■',
    }, {
        id: 9,
        code: 9,
        plot: 'path://m 50 90 l 43 -75 l -86 0 l 43 75 z',
        color: 'black',
        title: '',
        logo: '▼',
    },
]

/**
 * @deprecated since version 0.1
 */
const getNonConformSelectData = () => [
    { value: 1, label: i18n.conforms, conformity: ['blue'] },
    { value: 2, label: i18n.nonConform, conformity: ['red', 'orange', 'yellow', 'green'] },
    { value: 3, label: i18n.others, conformity: ['white'] },
]

const getRemarks = (id) => {
    return find(remarks, (o) => {
        return o.id == id
    }) || {}
}

const getResultFormat = ({ result, remark }) => {
    switch (remark) {
        case '0': return ''
        case '2':
        case '7':
        case '10': return isUndefined(result) ? '' : `<${result}`
        case '3': return isUndefined(result) ? '' : `>${result}`
        default:
            return isUndefined(result) ? '' : `${result}`
    }
}

const calculatePercentile90 = (list = [], centile = 0.9) => { // list should be ordered
    // old
    // if (list.length <= 9) {
    //     return list[list.length-2]
    // }
    // return list[floor(90 / 100 * list.length)]

    // v6
    if (list.length < 10) {
        return list[list.length - 1]
    }
    return list[round(centile * list.length - 0.45, 0)] // (0.9 * length - 0.55) - 1
}

const getQualificationColor = (qualification) => {
    return qualification ? ['GREEN', 'RED', 'ORANGE', 'GREY'][parseInt(qualification) - 1] : 'GREY'
}

const getQualificationIcon = qualification => {
    switch (parseInt(qualification)) {
        case 2: return 'error'
        case 3: return 'warning'
        case 4: return 'help'
        default: return ''
    }
}

const getStatusIcon = (status, statusList, style, withTooltip=true) => {
    if (hasValue(status)) {
        const icon = status ? [statusIconB, statusIconN1, statusIconN2, statusIconI][parseInt(status) - 1] : statusIconB
        return (
            <img
                src={ icon }
                className={ 'statusIcon' }
                style={ style }
                {...(withTooltip ? sieauTooltip(() => getLabel(statusList || getStatuses(), status)) : {})}
            />
        )
    }
    return null
}

const getStatusColor = (status) => {
    return status ? ['GREY', 'GREEN', 'DARKGREEN', 'BLUE'][parseInt(status) - 1] : 'GREY'
}

const getStatusAndResult = (obj, result, color = THRESHOLD_COLOR.white, withTooltip = false) => {
    const icon = statusIcon(obj, 30, withTooltip)
    return (
        <div className='valign-wrapper'>
            { icon }
            &nbsp;
            <div style={{ width: '100%', backgroundColor: color }}>
                { result }
            </div>
        </div>
    )
}

const ResultWithStatus = ({
    qualification = 4,
    status = 1,
    result = '',
    color = THRESHOLD_COLOR.white,
    iconSize = '16px',
    withTooltip = false,
}) => {
    return (
        <Grid2 container spacing={0.5} alignItems='center' sx={{ width: '100%' }}>
            <Grid2 size='auto'>
                <IconStatus
                    status={status}
                    qualification={qualification}
                    size={iconSize}
                    withTooltip={withTooltip}
                />
            </Grid2>
            <Grid2 size='grow' sx={{ backgroundColor: color }}>
                { result }
            </Grid2>
        </Grid2>
    )
}

ResultWithStatus.propTypes = {
    status: PropTypes.number,
    qualification: PropTypes.number,
    result: PropTypes.oneOfType([PropTypes.string, PropTypes.number ]),
    color: PropTypes.string,
    iconSize: PropTypes.string,
    withTooltip: PropTypes.bool,
}

const getLocalizationPicto = (localization) => {
    switch (localization) {
        case '0': return <i className='material-icons clickable' {...sieauTooltip(() => i18n.unknownLocalization)}>live_help</i>
        case '1': return <img className='clickable' {...sieauTooltip(() => i18n.insitu)} src={insitu} />
        case '2': return <img className='clickable' {...sieauTooltip(() => i18n.laboratory)} src={labo} />
        default: return ''
    }
}

const getLocalizationLabel = (localization) => {
    switch (localization) {
        case '0': return i18n.unknownLocalization
        case '1': return i18n.insitu
        case '2': return i18n.laboratory
        default: return ''
    }
}

const getAccreditationPicto = (accreditation) => {
    if (accreditation) {
        return <img className='clickable' src={ accreditationPicto } />
    }
    return undefined
}

/**
 * @deprecated since version 0.1
 */
const filterThresholdLevel = (analysis, thresholdLevel) => {
    if (isNil(thresholdLevel)) return true
    if (isNil(analysis.threshold)) return false
    switch (thresholdLevel) {
        case '0':
            return hasValue(analysis.threshold.threshold1) && analysis.result >= analysis.threshold.threshold1 && !analysis.value.includes('<')
        case '1':
            return hasValue(analysis.threshold.threshold2) && analysis.result >= analysis.threshold.threshold2 && !analysis.value.includes('<')
        case '2':
            return hasValue(analysis.threshold.threshold3) && analysis.result >= analysis.threshold.threshold3 && !analysis.value.includes('<')
        case '3':
            return hasValue(analysis.threshold.threshold4) && analysis.result >= analysis.threshold.threshold4 && !analysis.value.includes('<')
        case '4':
            return hasValue(analysis.threshold.threshold1) && (analysis.result < analysis.threshold.threshold1 || analysis.value.includes('<'))
        case '5':
            return hasValue(analysis.threshold.threshold2) && (analysis.result < analysis.threshold.threshold2 || analysis.value.includes('<'))
        case '6':
            return hasValue(analysis.threshold.threshold3) && (analysis.result < analysis.threshold.threshold3 || analysis.value.includes('<'))
        case '7':
            return hasValue(analysis.threshold.threshold4) && (analysis.result < analysis.threshold.threshold4 || analysis.value.includes('<'))
        case '8':
            const maxThreshold = `threshold${max([1, 2, 3, 4].filter(t => hasValue(analysis.threshold?.[`threshold${t}`]))) || 1}`
            return analysis.result < analysis.threshold.threshold1 || analysis.result >= analysis.threshold?.[maxThreshold]
        default:
            return true
    }
}

const getIconQualification = qualification => {
    switch (parseInt(qualification)) {
        case 1: return 'check_circle'
        case 2: return 'error'
        case 3: return 'warning'
        case 4: return 'help'
        default: return 'help'
    }
}

/* ################################
##########      NEW      ##########
################################ */

/* code remarque
  0: Analyse non faite
  1: Domaine de validité
  2: < seuil de détection
  3: > seuil de saturation
  4: Présence ou Absence
  5: Incomptable
  6: Taxons non individualisables
  7: Traces
  8: Dénombrement > Valeur
  9: Dénombrement < Valeur
  10: < au seuil de quantification
  11: Echelle absente
  12: Echelle non exploitable
*/
const quantificationRemark = ['1', '4', '6']
const detectionRemarkCodes = ['1', '3', '7', '8', '9', '10']

// filtre une liste d'analyses
const filterValid = (analysisList = []) => analysisList.filter(a => a.status === '2' || a.status === '3')
const filterResult = (analysisList = []) => analysisList.filter(a => a.remark !== '0' && (!isUndefined(a.result) || a.remark === '7'))
const filterQuantification = (analysisList = []) => analysisList.filter(a => a.remark && !(['0', '2', '3', '5', '7', '8', '9', '10'].includes(a.remark)))
const filterDetection = (analysisList = []) => analysisList.filter(a => detectionRemarkCodes.includes(a.remark))

// fonctions utils
const isQuantified = remark => quantificationRemark.includes(remark)

const calculateResult = analysis => {
    if (!analysis) {
        return
    }
    const {
        remarkCode,
        result,
        saturationThreshold,
    } = analysis
    return remarkCode === '3' && saturationThreshold || result
}

/**
 * Calcule le label du résultat à afficher pour une analyse
 * @param {Analysis} analysis - L'objet de l'analyse
 * @returns {string} - Le label du résultat formaté
 */
const calculateValue = analysis => {
    if (isNil(analysis)) {
        return ''
    }
    switch (analysis.remark) {
        case '0': // Analyse non faite
            return ''
        case '2': // < seuil de détection
        case '7': // Traces
        case '9': // Dénombrement < résultat
        case '10': // < au seuil de quantification
            return !isNil(analysis.result) ? `<${round(analysis.result, 5)}` : ''
        case '8': // Dénombrement > résultat
        case '3': // > seuil de saturation
            return !isNil(analysis.result) ? `>${round(analysis.saturationThreshold ?? analysis.result, 5)}` : ''
        default:
            return !isNil(analysis.result) ? `${round(analysis.result, 5)}` : ''
    }
}

// calcule sur une liste d'analyse
const searchMaxAnalysis = (analysisList = []) => {
    if (!analysisList.length) {
        return
    }
    const inferior = analysisList.filter(elem => elem.value.includes('<'))
    const superior = analysisList.filter(elem => elem.value.includes('>'))
    const tab = analysisList.filter(elem => !elem.value.includes('<') && !elem.value.includes('>'))
    return maxBy([...superior, ...tab, ...inferior], calculateResult)
}

const searchMaxResult = (analysisList = []) => {
    const analysis = searchMaxAnalysis(analysisList)
    const result = calculateResult(analysis)
    if (isUndefined(result)) {
        return
    }
    return round(result, 4)
}

const searchMaxValue = (analysisList = []) => {
    const analysis = searchMaxAnalysis(analysisList)
    return calculateValue(analysis)
}

const searchMinAnalysis = (analysisList = []) => {
    if (!analysisList.length) {
        return
    }
    const inferior = analysisList.filter(elem => elem.value.includes('<'))
    const superior = analysisList.filter(elem => elem.value.includes('>'))
    const tab = analysisList.filter(elem => !elem.value.includes('<') && !elem.value.includes('>'))
    return minBy([...inferior, ...tab, ...superior], calculateResult)
}

const searchMinResult = (analysisList = []) => {
    const analysis = searchMinAnalysis(analysisList)
    const result = calculateResult(analysis)
    if (isUndefined(result)) {
        return
    }
    return round(result, 4)
}

const searchMinValue = (analysisList = []) => {
    const analysis = searchMinAnalysis(analysisList)
    return calculateValue(analysis)
}

const searchP90Analysis = (analysisList = []) => {
    if (!analysisList.length) {
        return
    }
    const inferior = analysisList.filter(elem => elem.value.includes('<'))
    const superior = analysisList.filter(elem => elem.value.includes('>'))
    const tab = analysisList.filter(elem => !elem.value.includes('<') && !elem.value.includes('>'))

    const orderedInferior = orderBy(inferior, calculateResult)
    const orderedsSuperior = orderBy(superior, calculateResult)
    const orderedTab = orderBy(tab, calculateResult)

    return calculatePercentile90([...orderedInferior, ...orderedTab, ...orderedsSuperior])
}

const searchP90Result = (analysisList = []) => {
    const analysis = searchP90Analysis(analysisList)
    const result = calculateResult(analysis)
    if (isUndefined(result)) {
        return
    }
    return round(result, 4)
}

const searchP90Value = (analysisList = []) => {
    const analysis = searchP90Analysis(analysisList)
    return calculateValue(analysis)
}

const calculateAverage = (analysisList = [], settings = []) => {
    if (!analysisList.length) {
        return
    }

    const inferior = analysisList.filter(elem => elem.value.includes('<'))
    const tab = analysisList.filter(elem => !elem.value.includes('<'))

    if (!inferior.length) {
        return round(meanBy(tab, calculateResult), 3)
    }

    const methodLQ = getSetting(settings, 'TypeLimiteQuantification') || '3'

    if (methodLQ === '4') {
        const choosenLQValue = getSetting(settings, 'ValeurLimiteQuantification') || '0'
        const correctedInferior = inferior.map(a => ({ ...a, result: parseFloat(choosenLQValue) || 0 }))
        return round(meanBy([...correctedInferior, ...tab], calculateResult), 3)
    }

    if (methodLQ === '5') {
        if (!tab.length) {
            return
        }
        return round(meanBy(tab, calculateResult), 3)
    }
    // methodLQ === '3'
    const correctedInferior = inferior.map(a => ({ ...a, result: a.result / 2 }))
    return round(meanBy([...correctedInferior, ...tab], calculateResult), 3)
}

const calculateGeometricAverage = (list = []) => {
    if (!list.length) {
        return
    }
    const listResult = list.map(calculateResult)
    const filteredResult = listResult.filter(v => v > 0)
    const resultSum = filteredResult.reduce((acc, v) => acc + Math.log(v), 0)
    return round(Math.exp(resultSum / filteredResult.length), 3)
}

const searchQuartile = (arr, q) => {
    const pos = arr.length * q
    const index = ceil(pos)
    return calculateResult(arr[index])
}

const calculateRangeInterquartile = analysisList => {
    if (analysisList.length < 4) {
        return 0
    }

    const inferior = analysisList.filter(elem => elem.value.includes('<'))
    const superior = analysisList.filter(elem => elem.value.includes('>'))
    const tab = analysisList.filter(elem => !elem.value.includes('<') && !elem.value.includes('>'))

    const orderedInferior = orderBy(inferior, calculateResult)
    const orderedsSuperior = orderBy(superior, calculateResult)
    const orderedTab = orderBy(tab, calculateResult)

    const orderedList = [...orderedInferior, ...orderedTab, ...orderedsSuperior]

    const q1 = searchQuartile(orderedList, 0.25)
    const q3 = searchQuartile(orderedList, 0.75)
    return round(q3 - q1, 4)
}

const calculateStandardDeviation = analysisList => {
    if (!analysisList.length) {
        return
    }
    if (analysisList.length === 1) {
        return 0
    }
    const mean = calculateAverage(analysisList)
    const v = sum(analysisList.map(a => (calculateResult(a) - mean) ** 2))
    return round(Math.sqrt(v / (analysisList.length - 1)), 3)
}

export {
    calculatePercentile90,
    getRemarks,
    isQuantified,
    remarks,

    getQualificationColor,
    getStatusIcon,
    getStatusAndResult,
    getStatusColor,
    ResultWithStatus,
    getNonConformSelectData,
    getLocalizationPicto,
    getLocalizationLabel,
    getAccreditationPicto,
    getResultFormat,
    filterThresholdLevel,
    getQualificationIcon,
    getIconQualification,

    // new
    quantificationRemark,
    detectionRemarkCodes,

    filterValid,
    filterResult,
    filterQuantification,
    filterDetection,

    calculateResult,
    calculateValue,

    searchMaxAnalysis,
    searchMaxResult,
    searchMaxValue,
    searchMinAnalysis,
    searchMinResult,
    searchMinValue,
    searchP90Analysis,
    searchP90Result,
    searchP90Value,
    calculateAverage,
    calculateGeometricAverage,
    calculateRangeInterquartile,
    calculateStandardDeviation,
}
